export default __webpack_public_path__ + "static/media/create_apps.b6f03690.svg";